// D365 version badge component - 25 lines ✅
import { Badge } from '@/components/ui/badge'
import type { D365Version } from '@/types/database'

interface VersionBadgeProps {
  version: D365Version
  product?: string
  className?: string
}

export function VersionBadge({
  version,
  product,
  className,
}: VersionBadgeProps): JSX.Element {
  return (
    <Badge className={`bg-kaycoo-purple-pale text-kaycoo-purple-dark ${className || ''}`}>
      D365 {version}
      {product && ` (${product})`}
    </Badge>
  )
}
